import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../Services/commonDataService';
import { Global } from '../Shared/global';

@Component({
  selector: 'birthdays-widget',
  templateUrl: './birthdays.component.html',
  styleUrls: ['./dashboard-widgets.css']
})
export class BirthdaysComponent implements OnInit {

  count: number = 0;
  fromDate: Date = new Date();
  toDate: Date = new Date();

  constructor(private router: Router,
    private _service: CommonDataService) { }

  ngOnInit(): void {
    this.load();
  }

  load() {
    try {
      this._service.getData(Global.StringFormat(Global.BASE_USER_ENDPOINT() + Global.UsersBirthdayEndpoint, this.fromDate.toLocaleDateString('en-GB'), this.toDate.toLocaleDateString('en-GB')))
        .then((x: any) => { this.count = x?.TotalCount || (x?.ListItems ? x.ListItems.length : 0); })
        .catch(e => Global.Log(e));
    } catch (e) {
      Global.Log(e);
    }
  }

  viewDetails() {
    this.router.navigate(['/core/userbirthdays']);
  }

}
